import * as _ from "lodash";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { CheckManager } from "../../shared/check-manager";
import { FilterDataProvider } from "../../data-provider/filter.dp";
import { Filter } from "../../models/filter.model";
import { HouseOccupant } from "../../models/house-occupant.model";
import { PermissionCheck } from "../../shared/permission";
import { DialogUtils } from "../../helper/dialog.helper";
import { HouseOccupantDataProvider } from "../../data-provider/house-occupant.dp";
import { Field } from "../../models/field.model";
import { Appointment } from "../../models/appointment.model";
import { ToastUtils } from "../../helper/toast.helper";

let HouseOccupantComponent = {
    selector: "vcHouseOccupantComponent",
    templateUrl:
        "/angular/components/house-occupant/house-occupant.component.html",
    bindings: {
        group: "=?",
        hoid: "=?",
        checkboxes: "=?",
    },
    controller: class HouseOccupantComponentController {
        // * bindings for typescript compiler *
        public group?: any;
        public hoid?: any;
        public checkboxes?: any;
        // ************************************

        public filter: Filter;
        public isLeaderView: boolean;
        public essentialsMode: boolean;
        public headline: string;
        public subheading: string;
        public buttonText: string;
        public leader_subheading: string;
        public checkManager: CheckManager;
        public columns: object[];
        public previousFilter: object | undefined = undefined;
        public scrollViewOptions: any = {
            viewportOffset: [1000, 1000, 1000, 1000],
        };

        private $scope: any;
        private __env: any;
        private dialog: DialogUtils;
        private modelsUtils: any;

        public dataProvider: HouseOccupantDataProvider;
        public permissionProvider: PermissionCheck;
        public filterDataProvider: FilterDataProvider;
        public campaignDataProvider: CampaignDataProvider;
        private toast: ToastUtils;

        constructor(
            $scope: any,
            HouseOccupantDataProvider: HouseOccupantDataProvider,
            PermissionCheck: PermissionCheck,
            FilterDataProvider: FilterDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            __env: any,
            __app_type: string,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            ModelsUtils: any
        ) {
            this.$scope = $scope;
            this.__env = __env;
            this.dialog = DialogUtils;
            this.modelsUtils = ModelsUtils;
            this.toast = ToastUtils;

            this.dataProvider = HouseOccupantDataProvider;
            this.permissionProvider = PermissionCheck;
            this.filterDataProvider = FilterDataProvider;
            this.campaignDataProvider = CampaignDataProvider;
            this.dataProvider.clearAll();

            this.filterDataProvider.setPage("database");
            this.filter = FilterDataProvider.appliedFilter;
            this.isLeaderView = __app_type == "LEADER";
            this.essentialsMode =
                CampaignDataProvider.activeCampaign.campaignstatusid == "5";
            this.headline =
                "No " + this.__env.strings.voters + " to see here quite yet!";

            if (this.permissionProvider.hasPermission("IMPORT")) {
                this.subheading =
                    "Go to the Import Data page to upload your " +
                    this.__env.strings.voter_file +
                    " and populate this page";
                this.buttonText = "Import " + this.__env.strings.voters;
            }
            this.leader_subheading =
                "When your campaigns start importing " +
                this.__env.strings.voters +
                ", they'll show up here";
            this.checkManager = this.dataProvider.checkManager;
        }

        $onInit() {
            this.dataProvider.getColumns().then((columns: object[]) => {
                this.columns = columns;
                this.dataProvider.getAll(0, false);
            });

            if (this.hoid) {
                setTimeout(() => {
                    this.openViewHouseOccupantDialog(
                        this.modelsUtils.houseOccupant({
                            hoid: this.hoid,
                        })
                    );
                }, 500);
            }

            this.$scope.$watch(
                () => this.filter,
                (newValue: Filter, oldValue: Filter) => {
                    if (
                        !this.previousFilter ||
                        (newValue &&
                            !angular.equals(
                                newValue.nonEmptyValues(),
                                oldValue.nonEmptyValues()
                            )) ||
                        (Object.keys(newValue).length &&
                            !Object.keys(oldValue).length)
                    ) {
                        this.previousFilter = _.cloneDeep(newValue);
                        this.dataProvider.setFilters(this.filter, this.group);
                    }
                },
                true
            );
        }

        scrollLoad(offset: number): void {
            if (!this.dataProvider.scrollLoading) {
                this.dataProvider.getAll(offset, true);
            }
        }

        openAppointmentDialog(contact: HouseOccupant, ev: any): void {
            this.dialog
                .show({
                    component: "vc-appointment-form",
                    targetEvent: ev,
                    scope: this.$scope,
                    skipHide: true,
                    locals: {
                        contact: contact,
                    },
                    size: "large",
                    ariaLabel: "Appointment",
                })
                .then((updated: Appointment) => {
                    this.toast.success("Appointment created");
                });
        }

        openViewHouseOccupantDialog(
            houseoccupant: HouseOccupant,
            ev?: object
        ): void {
            this.dialog
                .show({
                    component: "vc-view-house-occupant",
                    targetEvent: ev,
                    scope: this.$scope,
                    skipHide: true,
                    clickOutsideToClose: true,
                    locals: {
                        selectedHoid: houseoccupant.hoid,
                    },
                    ariaLabel: "View Person",
                    size: "large",
                })
                .then((data: object) => {
                    houseoccupant.setData(data);
                });
        }

        openViewHouseDialog(houseoccupant: HouseOccupant, ev: object): void {
            this.dialog
                .show({
                    component: "vc-view-house",
                    targetEvent: ev,
                    skipHide: true,
                    clickOutsideToClose: true,
                    scope: this.$scope,
                    ariaLabel: "View House",
                    size: "large",
                    locals: {
                        selectedHouse: houseoccupant.house,
                        selectedHid: null,
                    },
                })
                .then((data: object) => {
                    _.merge(houseoccupant.house, data);
                });
        }

        openEditHouseOccupantDialog(
            houseoccupant: HouseOccupant,
            ev: object
        ): void {
            this.dialog
                .show({
                    component: "vc-house-occupant-form",
                    targetEvent: ev,
                    scope: this.$scope,
                    skipHide: true,
                    clickOutsideToClose: false,
                    locals: {
                        selectedHoid: houseoccupant.hoid,
                        selectedHid: null,
                    },
                    ariaLabel: "Person",
                    size: "large",
                })
                .then((data: object) => houseoccupant.setData(data));
        }

        customFieldValue(fields: Field[], cfid: string): any {
            if (fields && fields.length) {
                for (let i = 0; i < fields.length; i++) {
                    if (fields[i].cfid == cfid || fields[i].id == cfid) {
                        if (fields[i].cftid == 7) {
                            return fields[i].files;
                        } else {
                            return fields[i].value;
                        }
                    }
                }
            }
        }

        customFieldType(fields: Field[], cfid: string): string | null {
            if (fields && fields.length) {
                for (let i: number = 0; i < fields.length; i++) {
                    if (fields[i].cfid == cfid || fields[i].id == cfid) {
                        return fields[i].cftname;
                    }
                }
            }
            return null;
        }

        getCustomField(fields: Field[], cfid: string): any {
            if (fields && fields.length) {
                for (let i = 0; i < fields.length; i++) {
                    if (fields[i].cfid == cfid || fields[i].id == cfid) {
                        return fields[i];
                    }
                }
            }
        }

        electionValue(elections: any[], elid: string): any {
            if (elections && elections.length) {
                for (let i = 0; i < elections.length; i++) {
                    if (elections[i].elid == elid || elections[i].id == elid) {
                        return elections[i].hoevalue;
                    }
                }
            }
        }

        openCanvassDialog(houseoccupant: HouseOccupant, ev: object): void {
            if (this.essentialsMode) {
                this.dialog.show({
                    component: "vc-feature-disabled-dialog",
                    targetEvent: ev,
                    size: "large",
                    scope: this.$scope,
                    locals: {
                        essentials: true,
                    },
                });
            } else {
                this.dialog
                    .show({
                        component: "vc-canvass-form",
                        targetEvent: ev,
                        scope: this.$scope,
                        skipHide: true,
                        locals: {
                            selectedHouseOccupant: houseoccupant,
                            selectedHouse: null,
                            selectedCanvass: null,
                        },
                        size: "large",
                        ariaLabel: "Interaction",
                    })
                    .then((data: any) => {
                        houseoccupant.setData(data.houseoccupant);
                        houseoccupant.cssid = data.cssid;
                        houseoccupant.cssname = data.cssname;
                        houseoccupant.csreception = data.csreception;
                        houseoccupant.cscreationdatetime =
                            data.cscreationdatetime;
                        houseoccupant.cstype = "Walk";
                        houseoccupant.csscolor = data.csscolor;
                        houseoccupant.user = data.user;
                    });
            }
        }

        openSignatureDialog(signature: object, ev: object): void {
            this.dialog.show({
                component: "vc-view-signature-dialog",
                targetEvent: ev,
                scope: this.$scope,
                size: "medium",
                locals: {
                    signature: signature,
                },
            });
        }

        openViewUserDialog(uid: string, ev: object): void {
            this.dialog.show({
                component: "vc-view-organisation-user",
                targetEvent: ev,
                size: "large",
                scope: this.$scope,
                locals: {
                    selectedUser: null,
                    selectedUserId: uid,
                    editable: false,
                    onUserDeleted: null,
                    onUserUpdated: null,
                },
            });
        }

        showTutorialAlert(): void {
            const openInfoModal = this.dialog
                .confirm()
                .title("About The Recipients")
                .htmlContent(
                    '<p class="layout-padding no-side-padding">If a ' +
                        this.__env.strings.voter +
                        ' has selected "No contact" in contact preferences, ' +
                        " or they have indicated they would rather be contacted by phone, or " +
                        "they have unsubscribed from your emails, or previous attempts have either bounced or been marked as spam by the recipient, " +
                        "that " +
                        this.__env.strings.voter +
                        " will not show up here and no further emails will be sent to them.<p>" +
                        '<p class="layout-padding no-side-padding"> This means that the list of ' +
                        this.__env.strings.voters +
                        " shown here might differ slightly from the list shown on the" +
                        this.__env.strings.voters +
                        "page, even if the same filters are selected. </p>"
                )
                .ok("OK");
            this.dialog.showPreConfiguredDialog(openInfoModal);
        }
    },
};

angular
    .module("houseoccupant")
    .component(HouseOccupantComponent.selector, HouseOccupantComponent);
